import { useEffect, useState } from "react";
import Button from "src/components/Button";
import MainContentHeader from "src/components/MainContent/MainContentHeader";
import PanelLayout from "src/Layout/PanelLayout";
import NewJobDetailLvl1 from "./components/Forms/NewJobDetailLvl1";

export default function DataEntryPage() {
  const [isAdd, setIsAdd] = useState(false)

  


  const addMode = () => {
    setIsAdd(!isAdd);
  }

  return (
    <PanelLayout>
      <MainContentHeader title="شغل‌ها" isButton={true} buttonTitle="افزودن شغل جدید" clickHandle={addMode}/>
      <section className="flex mx-auto h-2/3 pt-4 justify-center items-center">
        <div className="space-y-4 text-center">
          <p>شغلی برای نمایش وجود ندارد</p>
          <Button title="افزودن شغل جدید" clickHandle={addMode}/>
        </div>
      </section>
      <NewJobDetailLvl1 isActive={isAdd} clickHandle={addMode}/>
    </PanelLayout>
  )
}